import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ShopSettingsService } from '../../modules/auth/shop-settings.service'
import { NgIf, AsyncPipe } from '@angular/common'
import { RouterOutlet } from '@angular/router'

@Component({
	selector: 'app-auth-layout',
	templateUrl: './auth-layout.component.html',
	styleUrls: ['./auth-layout.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgIf, RouterOutlet, AsyncPipe],
})
export class AuthLayoutComponent {
	private readonly shopSettingsService = inject(ShopSettingsService)

	logoUrl1$: Observable<string> = this.shopSettingsService.logoUrl1$
	logoUrl2$: Observable<string> = this.shopSettingsService.logoUrl2$
}
